// removed by extract-text-webpack-plugin
module.exports = {"container":"container___dnqR1","alphabetContainer":"alphabetContainer___3KeId","singeAlphabet":"singeAlphabet___3iVkz","title":"title___waD48","singleRowContainer":"singleRowContainer___3UukP","singleRow":"singleRow___2aAOX","headerLabel":"headerLabel___1qMqG","contentLabel":"contentLabel___2HgWg","tableContainer":"tableContainer___6gxAK","headerDivider":"headerDivider___hXtAX","contentDivider":"contentDivider___ujA5_","rowCheck":"rowCheck___hejxE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TableView/TableView.module.css
// module id = 366
// module chunks = 0